// src/pages/Cookies.jsx
import React from 'react';
import '../styles/components/privacy.css';

function Cookies({ region: _region }) {
  return (
    <main className="legal-page legal-page--cookies">
      <div className="container">
        <h1>Cookie Policy</h1>

        <p>
          This page explains how Pure Health Nexus uses cookies and similar technologies on our
          website and apps.
        </p>

        <h2>What are cookies?</h2>
        <p>
          Cookies are small text files stored on your device when you visit a website. They help
          the site function properly, remember your preferences, and understand how visitors use
          the site.
        </p>

        <h2>Types of cookies we use</h2>
        <ul>
          <li>
            <strong>Strictly necessary cookies</strong> – required for the website and apps to work
            (for example, keeping you logged in and providing basic security).
          </li>
          <li>
            <strong>Preference cookies</strong> – remember choices like language, region, and
            certain settings so we can tailor your experience.
          </li>
          <li>
            <strong>Analytics and performance cookies</strong> – help us understand how our site and
            tools are used so we can improve them, including aggregated statistics on visits,
            clicks and feature usage.
          </li>
          <li>
            <strong>Marketing or affiliate cookies</strong> – used, where applicable, to track
            referrals, clicks on product links and measure the performance of our recommendations.
          </li>
        </ul>

        <h2>Cookie choices and consent</h2>
        <p>
          Where required by law, non essential cookies (such as analytics and marketing cookies)
          are only used with your consent. You can manage your cookie choices in our cookie banner
          and by adjusting your browser settings.
        </p>

        <h2>Managing cookies in your browser</h2>
        <p>
          Most browsers let you block, delete, or limit cookies. If you block certain cookies,
          some features of our website or apps may not work as intended.
        </p>

        <h2>Changes to this policy</h2>
        <p>
          We may update this Cookie Policy from time to time. If the changes are significant, we
          will provide a clear notice on the site or in the app.
        </p>

        <h2>Contact</h2>
        <p>
          If you have questions about our use of cookies, you can contact us at&nbsp;
          <a href="mailto:info@purehealthnexus.com">info@purehealthnexus.com</a>.
        </p>
      </div>
    </main>
  );
}

export default Cookies;
